export enum EnumParams{
  personKind="personKind",
  contractId='contractId'
}
